/* ============================================================
   WonderWorks Lab — Shared Scripts
   ============================================================ */

(function () {
  'use strict';

  // ---- Mobile Nav Toggle ----
  var mobileToggle = document.querySelector('.mobile-toggle');
  var siteNav = document.querySelector('.site-nav');
  var mobileClose = document.querySelector('.mobile-close');

  if (mobileToggle && siteNav) {
    mobileToggle.addEventListener('click', function () {
      siteNav.classList.toggle('active');
      var isOpen = siteNav.classList.contains('active');
      mobileToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  if (mobileClose && siteNav) {
    mobileClose.addEventListener('click', function () {
      siteNav.classList.remove('active');
      mobileToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  }

  // ---- Nav Dropdown Toggle ----
  document.querySelectorAll('.nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var parent = this.closest('.nav-item');
      var isOpen = parent.classList.contains('open');

      // Close all dropdowns first
      document.querySelectorAll('.nav-item.open').forEach(function (item) {
        item.classList.remove('open');
        var toggle = item.querySelector('.nav-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });

      // Toggle current
      if (!isOpen) {
        parent.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-item')) {
      document.querySelectorAll('.nav-item.open').forEach(function (item) {
        item.classList.remove('open');
        var toggle = item.querySelector('.nav-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // ---- FAQ Accordion ----
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');

      // Close all FAQ items
      document.querySelectorAll('.faq-item.open').forEach(function (faq) {
        faq.classList.remove('open');
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('open');
      }
    });
  });

  // ---- Filter Tags (shop pages) ----
  document.querySelectorAll('.filter-tag').forEach(function (tag) {
    tag.addEventListener('click', function () {
      this.closest('.filter-group').querySelectorAll('.filter-tag').forEach(function (t) {
        t.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

})();
